<template>
    <article v-if='article !== undefined' class="news-article">
        <div class="panel panel--content panel--heading">
            <div class="panel__body">
                <nav v-if="breadcrumbs !== null" class="breadcrumb" id="post-breadcrumbs"><div v-html="breadcrumbs"></div></nav>
                <h1 id="page-title" class="article_title">{{ article.title }}</h1>
                <div class="article__details">
                    <div v-if="article.author_url && article.author_url.length > 0" itemprop="name" class="h4">
                        <a rel="author" :href="article.author_url">{{ article.author_name }}</a>
                    </div>
                    <div v-else itemprop="name" class="h4" style="color:#005689;">
                        {{ article.author_name }}
                    </div>
                    <time class="article__date" pubdate="pubdate" :datetime="article.date">{{ article.date }}</time>
                    <div v-if="article.categories.length > 0" class="article__tags">
                        <span v-for="category in article.categories" :key="category.value">
                            <a v-if="category.name !== 'Uncategorized' && post_type == 'kent_ac_uk'" :href="'https://www.kent.ac.uk/news?category='+category.value" class="button button--blue button-tag" style="margin-right:5px;">
                                {{ category.name }}
                            </a>
                            <a v-if="category.name !== 'Uncategorized' && post_type == 'external_feed'" :href="'https://blogs.kent.ac.uk/'+blog_domain+'/category/'+category.value" class="button button--blue button-tag" style="margin-right:5px;">
                                {{ category.name }}
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="news_article panel panel--content panel--grid-content panel--article-body">
            <div class="panel__body">
                <div class="content content--main">
                    <figure v-if="article.banner_image && hide_banner == false" class="figure figure--center figure--full figure--header">
                        <div v-if="article.image_caption.length > 0" class="figure__image-and-attribution">
                            <img :src="article.banner_image" :alt="article.image_caption">
                            <div class="attribution">
                                <i class="ki-camera"></i>
                                <span>
									{{ article.image_caption }}
                                </span>
                            </div>
                        </div>
                        <img v-else :src="article.banner_image" :alt="article.title">
                    </figure>
                    <div class="article__content" v-html="article.content"></div>
                    <div v-if="article.tags.length > 0" class="article__tags">
                        <span v-for="tag in article.tags" :key="tag.value">
                            <a v-if="tag.name !== 'Uncategorized' && post_type == 'kent_ac_uk'" :href="'https://www.kent.ac.uk/news?tag='+tag.value" class="button button--tag">
                                {{ tag.name }}
                            </a>
                            <a v-if="tag.name !== 'Uncategorized' && post_type == 'external_feed'" :href="'https://blogs.kent.ac.uk/'+blog_domain+'/tag/'+tag.value" class="button button--tag">
                                {{ tag.name }}
                            </a>
                        </span>
                    </div>
                    <aside v-if="article.canonical_url.length > 0" class="article__footer">
                        <p>This is a repurposed version of a blog post and may differ from the original. <a :href="article.canonical_url">View the original blog post</a>.</p>
                    </aside>
                </div>
                <aside v-if="social_share" class="content content--aside content--aside-bottom share-news-post">
                    <nav role="navigation" aria-labelledby="link-listing__title--share-post">
                        <h2 class="link-listing__title" id="link-listing__title--share-post">Share this post</h2>
                        <ul>
                            <li>
                                <a class="button button--social button--twitter-color button--twitter-color-hover" :href="'https://twitter.com/intent/tweet?url=' + url + '&text=' + post_title" target="_blank" title="Share this post on Twitter">
                                    <span class="sr-only"></span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="28" viewBox="0 0 26 28">
                                        <path d="M25.312 6.375q-1.047 1.531-2.531 2.609 0.016 0.219 0.016 0.656 0 2.031-0.594 4.055t-1.805 3.883-2.883 3.289-4.031 2.281-5.047 0.852q-4.234 0-7.75-2.266 0.547 0.063 1.219 0.063 3.516 0 6.266-2.156-1.641-0.031-2.938-1.008t-1.781-2.492q0.516 0.078 0.953 0.078 0.672 0 1.328-0.172-1.75-0.359-2.898-1.742t-1.148-3.211v-0.063q1.062 0.594 2.281 0.641-1.031-0.688-1.641-1.797t-0.609-2.406q0-1.375 0.688-2.547 1.891 2.328 4.602 3.727t5.805 1.555q-0.125-0.594-0.125-1.156 0-2.094 1.477-3.57t3.57-1.477q2.188 0 3.687 1.594 1.703-0.328 3.203-1.219-0.578 1.797-2.219 2.781 1.453-0.156 2.906-0.781z"></path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="button button--social button--facebook-color button--facebook-color-hover" :href="'https://www.facebook.com/sharer/sharer.php?u=' + url" target="_blank" title="Share this post on Facebook">
                                    <span class="sr-only"></span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 1792 1792">
                                        <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="button button--social button--linkedin-color button--linkedin-color-hover" :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + url" target="_blank" title="Share this post on LinkedIn">
                                    <span class="sr-only"></span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="14" viewBox="0 0 12 14">
                                        <path d="M2.727 4.883v7.742h-2.578v-7.742h2.578zM2.891 2.492q0.008 0.57-0.395 0.953t-1.059 0.383h-0.016q-0.641 0-1.031-0.383t-0.391-0.953q0-0.578 0.402-0.957t1.051-0.379 1.039 0.379 0.398 0.957zM12 8.187v4.437h-2.57v-4.141q0-0.82-0.316-1.285t-0.988-0.465q-0.492 0-0.824 0.27t-0.496 0.668q-0.086 0.234-0.086 0.633v4.32h-2.57q0.016-3.117 0.016-5.055t-0.008-2.313l-0.008-0.375h2.57v1.125h-0.016q0.156-0.25 0.32-0.438t0.441-0.406 0.68-0.34 0.895-0.121q1.336 0 2.148 0.887t0.813 2.598z"></path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="button button--social button--youtube-color button--youtube-color-hover" :href="'mailto:?&subject=&cc=&bcc=&body=' + url + '%0A' + post_title" target="_blank" title="Share this post via email">
                                    <span class="sr-only"></span>
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 19 12">
                                        <path d="M17.5 0h-16C.7 0 0 .7 0 1.5v9c0 .8.7 1.5 1.5 1.5h16c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5zm0 1s.1 0 0 0l-7.4 5c-.3.2-.9.2-1.2 0L1.4 1h16.1zm0 10h-16c-.3 0-.5-.2-.5-.5V1.9l7.4 4.9c.3.2.7.3 1.1.3s.8-.1 1.1-.3L18 1.9v8.6c0 .3-.2.5-.5.5z"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </aside>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        post_type: String,
        breadcrumbs: String,
        article: String,
        url: String,
        social_share: Boolean
    },
    data() {
        return {
            post_title: '',
            hide_banner: false,
            blog_domain: ''
        }
    },
    methods: {
        encode_article_title() {
            this.post_title = encodeURIComponent(this.article.title.trim());
        },
        matching_image_in_content() {
            // We strip out the http part to ensure we find the image
            let banner_image = this.article.banner_image
            banner_image = banner_image.replace('http://', '');
            banner_image = banner_image.replace('https://', '');
            // Setup the regex
            var regex = new RegExp(banner_image, 'g');
            // Now check
            var match = this.article.content.match(regex);
            if(match != null) {
                this.hide_banner = true;
            }
        },
        reset_title_tag() {
            document.title = unescape(this.article.title);
            let title_el = document.querySelector('title');
            title_el.innerHTML = unescape(this.article.title);
        },
        get_article_url() {
            var permalink = this.article.canonical_url;
            permalink = permalink.split('/');
            this.blog_domain = permalink[3];
        }
    },
    created() {
        if(this.article !== undefined) {
            // Format the post title for use on social media links
            this.encode_article_title();
            // Reset the title tags
            this.reset_title_tag();
            // Check for banner image in content
            this.matching_image_in_content();
            // Get the blogs original domain name for use in category and tag lookups
            this.get_article_url();
        }
    }
}
</script>
